<script>
  import { fmtNum, fmtPct } from '../utils/format.js';

  /**
   * Dark band on top of the tooltip. Background is the winner party's
   * colour, text colour is computed for legibility by the parent.
   */
  let { record, bgColor, textColor } = $props();

  const displayName = $derived(record.name || record.prov || '');
  const subtitle = $derived(
    record.name && record.prov && record.prov !== record.name ? record.prov : ''
  );
</script>

<div class="tooltip-header" style:background={bgColor} style:color={textColor}>
  <div class="first-item">
    <div class="tooltip-name">
      {displayName}
      {#if subtitle}
        <span class="tooltip-subtitle">{subtitle}</span>
      {/if}
      <div>
        <span class="tooltip-turnout">
          <span class="label-category">Participación</span>: {fmtPct(record.participacion_pct, 2)}
        </span>
        <span style="font-weight:100;"> | </span>
        <span class="tooltip-turnout">
          <span class="label-category">Censo</span>: {fmtNum(record.censo)}
        </span>
      </div>
    </div>
  </div>
</div>
